<template>
    <div class="contact-info-section pt-100 pb-100">
        <div class="container">
            <div class="section-title section-title-lg">
                <small>{{ infoCopy.subtitle }}</small>
                <h2>{{ infoCopy.title }}</h2>
                <p>{{ infoCopy.description }}</p>
            </div>
            <!-- Contact-info -->
            <div class="contact-info-wrapper">
                <div class="contact-info mb-15">
                    <div class="row" style="position: relative; top: -15px;">
                    <div
                        class="col-md-6 col-lg-4 pb-30"
                        v-for="(item, index) in infoItems"
                        :key="item.title"
                    >
                        <div class="contact-info-item">
                            <div class="contact-info-header">
                                <div class="contact-info-header-icon">
                                    <img v-lazy="icons[index]" :alt="item.alt || item.title" />
                                </div>
                                <div class="contact-info-header-text">
                                    <h3>{{ item.title }}</h3>
                                    <p>{{ item.subtitle }}</p>
                                </div>
                            </div>
                            <div class="contact-info-body">
                                <p v-for="line in item.lines" :key="line.text">
                                    <template v-if="line.link">
                                        <a :href="line.link">{{ line.text }}</a>
                                    </template>
                                    <template v-else>
                                        {{ line.text }}
                                    </template>
                                </p>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <!-- Contact-info -->
        </div>
    </div>
</template>

<script>
export default {
    name: 'ContactInfo',
    computed: {
        infoCopy() {
            const info = this.$t('contact.info')
            return typeof info === 'object' ? info : {}
        },
        infoItems() {
            return this.infoCopy.items || []
        },
        icons() {
            return [
                this.$ossImg('contact/address.png'),
                this.$ossImg('contact/phone.png'),
                this.$ossImg('contact/email.png')
            ]
        }
    }
}
</script>

<style scoped>
/* Wrapper for stacked effect */
.contact-info-wrapper {
    position: relative;
}

/* Background block (stacked effect) */


/* Main card (white block on top) */
.contact-info {
    position: relative;
    z-index: 1;
    background-color: #fff !important;
}
</style>
